<div
  id="chat-window-container"
  class="fixed inset-0 sm:inset-auto sm:bottom-2 sm:right-8 sm:left-auto w-full h-full sm:max-w-[392px] sm:h-[600px] bg-white rounded-none sm:rounded-[10px] shadow-[0px_6px_10px_0px_rgba(0,0,0,0.08)] shadow-[0px_-1px_10px_0px_rgba(0,0,0,0.08)] overflow-hidden"
>
  @switch (chatStore.ui.activeTab()) {
    @case ('channels') {
      <stream-channel-list (click)="gotoActiveChat($event)">
        <div channel-list-top>
          <div class="h-[72px] w-full bg-[#212e4a]">
            <div class="flex items-center justify-between h-full px-6">
              <button
                class="w-8 h-8 rounded-full bg-white disabled:bg-[#d1d1d1] disabled:cursor-not-allowed flex items-center justify-center"
                [disabled]="createChatDisabled() || chatStore.data.creating()"
                (click)="onCreateNewChatClick()"
              >
                <lucide-angular [color]="createChatDisabled() ? 'white' : '#212e4a'" name="square-pen" size="16" />
              </button>
              <span class="text-center text-white text-lg font-medium leading-[27px] tracking-tight"
                >Chat with a vet</span
              >
              <lucide-angular
                name="minus"
                color="white"
                class="cursor-pointer"
                (click)="chatStore.ui.toggleWidget()"
              ></lucide-angular>
            </div>
          </div>
        </div>
      </stream-channel-list>
    }
    @case ('pet-selection') {
      <app-chat-pet-selection
        (petConfirmed)="onPetConfirmed($event)"
        (back)="onPetSelectionBack()"
        (dismissed)="onPetSelectionClose()"
      />
    }
    @case ('chat') {
      <div class="relative w-full">
        <stream-channel>
          <app-chat-header />
          <stream-message-list data-automationid="stream-message-list"></stream-message-list>
          <stream-notification-list></stream-notification-list>
          <app-ai-status [channelID]="chatStore.conn.activeChannel()?.id" [ai_status]="chatStore.conn.ai_status()" />
          @if (currentChat()?.status !== chatStatus.paymentRequired) {
            <stream-message-input
              [displaySendButton]="chatStore.conn.ai_status() === ''"
              [inputMode]="chatStore.conn.ai_status() === '' ? 'desktop' : 'mobile'"
              data-automationid="stream-message-input"
            ></stream-message-input>
          }
          <stream-thread name="thread">
            @if (currentChat()?.status !== chatStatus.paymentRequired) {
              <stream-message-list mode="thread"></stream-message-list>
              <stream-message-input mode="thread"></stream-message-input>
            }
          </stream-thread>
          <app-chat-window-payment [currentChat]="currentChat()" />
        </stream-channel>
      </div>
    }
  }
</div>

<ng-template #customAttachmentPreviews let-attachments="attachments" let-channel="channel" let-messageId="messageId">
  @for (attachment of attachments; track $index) {
    @if (attachment.type === 'call') {
      @switch (attachment.state) {
        @case ('Ready') {
          <app-incoming-call-message
            [staffName]="attachment.staff_name"
            [staffImage]="attachment.staff_picture"
            [callId]="attachment.room_id"
            [chatId]="currentChatId()"
          ></app-incoming-call-message>
        }
        @case ('InProgress') {
          <app-inprogress-call-message
            [staffName]="attachment.staff_name"
            [staffImage]="attachment.staff_picture"
            [callId]="attachment.room_id"
            [chatId]="currentChatId()"
          ></app-inprogress-call-message>
        }
        @case ('Complete') {
          <app-ended-call-message
            [staffName]="attachment.staff_name"
            [staffImage]="attachment.staff_picture"
            [duration]="attachment.duration"
          ></app-ended-call-message>
        }
        @case ('Disrupted') {
          <app-disrupted-call-message
            [staffName]="attachment.staff_name"
            [staffImage]="attachment.staff_picture"
          ></app-disrupted-call-message>
        }
        @case ('Missed') {
          <app-missed-call-message
            [staffName]="attachment.staff_name"
            [staffImage]="attachment.staff_picture"
          ></app-missed-call-message>
        }
      }
    }
    @if (attachment.type === 'product') {
      <app-product-message
        [currency]="attachment.currency"
        [productName]="attachment.name"
        [productImage]="attachment.photo_url"
        [productPrice]="attachment.price"
        [productUrl]="attachment.url"
      ></app-product-message>
    }
    @if (attachment.type === 'genericButton') {
      <app-generic-chat-button-attachment
        class="block"
        [attachment]="attachment"
        [chatId]="currentChatId()"
        [messageId]="messageId"
        [buttonStyleType]="$index > 0 ? 'secondary' : 'primary'"
      />
    }
  }
</ng-template>

@if (showProductsOverlay) {
  <section class="w-full h-full fixed top-0 left-0 bg-white overflow-scroll z-2">
    @if (recommendedProductsResponse) {
      <header class="w-full joii-bg-primary">
        <div class="max-w-[800px] mx-auto p-15 pb-30 text-white relative">
          <span
            class="text-white absolute top-10 right-5 cursor-pointer z-2"
            role="button"
            tabindex="0"
            (click)="closeProductOverlay()"
            (keydown.enter)="closeProductOverlay()"
          >
            <ng-icon name="ionCloseSharp" size="30"></ng-icon>
          </span>
          @if (recommendedProductsResponse.pet_name && recommendedProductsResponse.staff_name) {
            <h1 class="text-xl font-bold">Prescribed for {{ recommendedProductsResponse.pet_name }}</h1>
            <p>
              Get a head start on {{ recommendedProductsResponse.pet_name }}'s care! Order now while
              {{ recommendedProductsResponse.staff_name }} finalises your treatment plan.
            </p>
          }
        </div>
      </header>
      <section class="max-w-[800px] mx-auto relative -top-[80px] pl-15 pr-15 text-center">
        @for (product of recommendedProductsResponse.recommended_products; track product) {
          <article class="w-1/2 inline-block pr-2 pl-2 pb-5 mx-auto text-left">
            <a [href]="product.product_url" target="_blank">
              <div class="bg-white rounded-lg overflow-hidden aspect-1">
                <img
                  [src]="product.product_image"
                  [title]="product.product_name"
                  [alt]="product.product_name"
                  class="align-middle"
                />
              </div>
            </a>
            <p class="font-medium mt-2">{{ product.product_name }}</p>
            <p class="font-medium mt-1">{{ product.product_price / 100 | currency: product.currency : true }}</p>
          </article>
        }
      </section>
      <footer class="pb-10 relative -top-[50px]">
        <p class="text-center mt-5">
          <a
            role="button"
            tabindex="0"
            (click)="goToBasket(recommendedProductsResponse.basket_url)"
            (keydown.enter)="goToBasket(recommendedProductsResponse.basket_url)"
            class="w-full joii-btn-primary action-button max-w-96"
            >Buy now</a
          >
        </p>
        <p class="text-center">
          <a
            role="button"
            tabindex="0"
            (click)="goToCart(recommendedProductsResponse.cart_url)"
            (keydown.enter)="goToCart(recommendedProductsResponse.cart_url)"
            class="w-full joii-btn-outline action-button max-w-96 mt-2"
            >Add
            @if (recommendedProductsResponse.recommended_products.length > 1) {
              <span>&nbsp;all&nbsp;</span>
            }
            to basket</a
          >
        </p>
      </footer>
    }
  </section>
}
